import parse, { DOMNode, HTMLReactParserOptions, domToReact } from "html-react-parser";
import { HTMLElement, parse as htmlParse } from 'node-html-parser';
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { BaselineQuery } from "../components/source-components/array-sources/BaselineQuery";
import { ChatbotHistory } from "../components/source-components/array-sources/ChatbotHistory";
import { ConstantArray } from "../components/source-components/array-sources/ConstantArray";
import { Favorites } from "../components/source-components/array-sources/Favorites";
import { ContentStructureScanner } from "../components/source-components/array-sources/ContentStructureScanner";
import { CustomPropertyFilterNames } from "../components/source-components/array-sources/CustomPropertyFilterNames";
import { CustomPropertyFilterValues } from "../components/source-components/array-sources/CustomPropertyFilterValues";
import { CustomPropertyNamesQuery } from "../components/source-components/array-sources/CustomPropertyNamesQuery";
import { CustomPropertyValuesQuery } from "../components/source-components/array-sources/CustomPropertyValuesQuery";
import { ItemChildren } from "../components/source-components/array-sources/ItemChildren";
import { ItemPropertyNames } from "../components/source-components/array-sources/ItemPropertyNames";
import { ItemPropertyValues } from "../components/source-components/array-sources/ItemPropertyValues";
import { LanguageValuesQuery } from "../components/source-components/array-sources/LanguageValuesQuery";
import { LinkedBooks } from "../components/source-components/array-sources/LinkedBooks";
import { SearchQuery } from "../components/source-components/array-sources/SearchQuery";
import { SimilarQuery } from "../components/source-components/array-sources/SimilarQuery";
import { StoredArray } from "../components/source-components/array-sources/StoredArray";
import { SystemPropertyFilterNames } from "../components/source-components/array-sources/SystemPropertyFilterNames";
import { SystemPropertyFilterValues } from "../components/source-components/array-sources/SystemPropertyFilterValues";
import { SystemPropertyValuesQuery } from "../components/source-components/array-sources/SystemPropertyValuesQuery";
import { UsedByQuery } from "../components/source-components/array-sources/UsedByQuery";
import { ValidityMatrix } from "../components/source-components/array-sources/ValidityMatrix";
import { ValidityPath } from "../components/source-components/array-sources/ValidityPath";
import { ValidityPropertyFilterValues } from "../components/source-components/array-sources/ValidityPropertyFilterValues";
import { ValidityValuesQuery } from "../components/source-components/array-sources/ValidityValuesQuery";
import { CompareArray } from "../components/source-components/array-transformers/CompareArray";
import { FilterArray } from "../components/source-components/array-transformers/FilterArray";
import { SortArray } from "../components/source-components/array-transformers/SortArray";
import { FormatDate } from "../components/source-components/string-processors/FormatDate";
import { InsertInlineTag } from "../components/source-components/string-processors/InsertInlineTag";
import { ParseHtml } from "../components/source-components/string-processors/ParseHtml";
import { StringLength } from "../components/source-components/string-processors/StringLength";
import { Substring } from "../components/source-components/string-processors/Substring";
import { ArrayLength } from "../components/source-components/value-sources/ArrayLength";
import { CustomFilter } from "../components/source-components/value-sources/CustomFilter";
import { ItemHasChildren } from "../components/source-components/value-sources/ItemHasChildren";
import { ItemPosition } from "../components/source-components/value-sources/ItemPosition";
import { ItemProperty } from "../components/source-components/value-sources/ItemProperty";
import { ItemValue } from "../components/source-components/value-sources/ItemValue";
import { SiteConfigurationValue } from "../components/source-components/value-sources/SiteConfigurationValue";
import { LabelTerm } from "../components/source-components/value-sources/LabelTerm";
import { MarkdownExportUrl } from "../components/source-components/value-sources/MarkdownExportUrl";
import { PathHasMarkdownChunks } from "../components/source-components/value-sources/PathHasMarkdownChunks";
import { SystemFilter } from "../components/source-components/value-sources/SystemFilter";
import { SystemVersion } from "../components/source-components/value-sources/SystemVersion";
import { Term } from "../components/source-components/value-sources/Term";
import { WindowWidth } from "../components/source-components/value-sources/WindowWidth";
import { AddFavorite } from "../components/user-functions/AddFavorite";
import { ApplyButton } from "../components/user-functions/ApplyButton";
import { AppLink } from "../components/user-functions/AppLink";
import { BaselineSelector } from "../components/user-functions/BaselineSelector";
import { BranchState } from "../components/user-functions/BranchState";
import { CallbackButton } from "../components/user-functions/CallbackButton";
import { CallbackInput } from "../components/user-functions/CallbackInput";
import { ChangePasswordButton } from "../components/user-functions/ChangePasswordButton";
import { Chatbot } from "../components/user-functions/Chatbot";
import { ChatbotPrompt } from "../components/user-functions/ChatbotPrompt";
import { CssClassRules } from "../components/user-functions/CssClassRules";
import { CustomElement } from "../components/user-functions/CustomElement";
import { CustomPropertySelector } from "../components/user-functions/CustomPropertySelector";
import { DirectLink } from "../components/user-functions/DirectLink";
import { MarkdownExportLink } from "../components/user-functions/MarkdownExportLink";
import { DisplayValueControl } from "../components/user-functions/DisplayValueControl";
import { DownloadCart } from "../components/user-functions/DownloadCart";
import { ForChildren } from "../components/user-functions/ForChildren";
import { ForEach } from "../components/user-functions/ForEach";
import { ForgotPasswordButton } from "../components/user-functions/ForgotPasswordButton";
import { FilterStateController } from "../components/user-functions/FilterStateController";
import { FormManager } from "../components/user-functions/FormManager";
import { If } from "../components/user-functions/If";
import { IncludeImage } from "../components/user-functions/IncludeImage";
import { InjectElementRules } from "../components/user-functions/InjectElementRules";
import { LanguageSelector } from "../components/user-functions/LanguageSelector";
import { LinkController } from "../components/user-functions/LinkController";
import { LinkVerifier } from "../components/user-functions/LinkVerifier";
import { LoginButton } from "../components/user-functions/LoginButton";
import { LogoutButton } from "../components/user-functions/LogoutButton";
import { SignInButton } from "../components/user-functions/SignInButton";
import { OpenDialogButton } from "../components/user-functions/OpenDialogButton";
import { BookOutlet } from "../components/user-functions/BookOutlet";
import { FileOutlet } from "../components/user-functions/FileOutlet";
import { Facade } from "../components/user-functions/Facade";
import { PageLoader } from "../components/user-functions/PageLoader";
import { RemoveFavorite } from "../components/user-functions/RemoveFavorite";
import { RenderPath } from "../components/user-functions/RenderPath";
import { ResizableColumn } from "../components/user-functions/ResizableColumn";
import { ResizableColumnController } from "../components/user-functions/ResizableColumnController";
import { SetCurrentSearchHitButton } from "../components/user-functions/SetCurrentSearchHitButton";
import { SetCurrentVerifiedLinkButton } from "../components/user-functions/SetCurrentVerifiedLinkButton";
import { StateBooleanCheckbox } from "../components/user-functions/StateBooleanCheckbox";
import { StateSetterInput } from "../components/user-functions/StateSetterInput";
import { StateStringInput } from "../components/user-functions/StateStringInput";
import { StoreArray } from "../components/user-functions/StoreArray";
import { SystemPropertySelector } from "../components/user-functions/SystemPropertySelector";
import { ToggleSwitch } from "../components/user-functions/ToggleSwitch";
import { ToggleSwitchController } from "../components/user-functions/ToggleSwitchController";
import { ValiditySelector } from "../components/user-functions/ValiditySelector";
import { evaluateBooleanExpression } from "../shared/utils/expression.utils";
import { fixInternalImages, fixInternalLinks } from "../shared/utils/path-rewrite.utils";
import { useCreateInternalStateBranch, useCssClassRules, useInjectElementRules, useInternalState } from "./InternalContext";
import { useSiteContext } from "./SiteContext";
import { InjectElementRule } from "./state-types";
import { useBookOutletScope } from "./BookOutletScopeContext";
import { useFileOutletScope } from "./FileOutletScopeContext";


// Component for passing through content
function PassThrough({ children }: { children: React.ReactNode }): React.ReactElement {
    return <>{children}</>;
}

function UnmanagedContent({ unparsedHtml }: { unparsedHtml: string }): React.ReactElement {
    return <div dangerouslySetInnerHTML={{ __html: unparsedHtml }} />;
}

const deprecatedComponents: Record<string, { Replacement: React.FC<any>, tag: string, message: string }> = {
    "pagerouter": {
        Replacement: FileOutlet,
        tag: "PageRouter",
        message: "Use FileOutlet instead. It is currently a backwards compatibility alias for FileOutlet and will be completely removed in a future version."
    },
    "storemetadata": {
        Replacement: PassThrough,
        tag: "StoreMetadata",
        message: "It has no effect and will be completely removed in a future version."
    },
    "textfilter": {
        Replacement: StateStringInput,
        tag: "TextFilter",
        message: "Use StateStringInput instead. It is currently a backwards compatibility alias for StateStringInput and will be completely removed in a future version."
    },
    "loginbutton": {
        Replacement: LoginButton,
        tag: "LoginButton",
        message: "Use SignInButton, LogoutButton, and ChangePasswordButton instead."
    }
};

/***
 * List of all supported React components in included files
 */
const customComponentMap: Record<string, React.FC<any>> = {
    "addfavorite": AddFavorite,
    "applink": AppLink,
    "applybutton": ApplyButton,
    "arraylength": ArrayLength,
    "baselinequery": BaselineQuery,
    "baselineselector": BaselineSelector,
    "branchstate": BranchState,
    "callbackbutton": CallbackButton,
    "callbackinput": CallbackInput,
    "chatbothistory": ChatbotHistory,
    "chatbot": Chatbot,
    "chatbotprompt": ChatbotPrompt,
    "comparearray": CompareArray,
    "constantarray": ConstantArray,
    "contentstructurescanner": ContentStructureScanner,
    "cssclassrules": CssClassRules,
    "customfilter": CustomFilter,
    "custompropertyfilternames": CustomPropertyFilterNames,
    "custompropertyfiltervalues": CustomPropertyFilterValues,
    "custompropertynamesquery": CustomPropertyNamesQuery,
    "custompropertyselector": CustomPropertySelector,
    "custompropertyvaluesquery": CustomPropertyValuesQuery,
    "difference": CompareArray,
    "directlink": DirectLink,
    "displayvaluecontrol": DisplayValueControl,
    "downloadcart": DownloadCart,
    "customelement": CustomElement,
    "facade": Facade,
    "favorites": Favorites,
    "filterarray": FilterArray,
    "forchildren": ForChildren,
    "foreach": ForEach,
    "formatdate": FormatDate,
    "formmanager": FormManager,
    "if": If,
    "includeimage": IncludeImage,
    "injectelementrules": InjectElementRules,
    "insertinlinetag": InsertInlineTag,
    "itemchildren": ItemChildren,
    "itemhaschildren": ItemHasChildren,
    "itemposition": ItemPosition,
    "itemproperty": ItemProperty,
    "itempropertynames": ItemPropertyNames,
    "itempropertyvalues": ItemPropertyValues,
    "itemvalue": ItemValue,
    "siteconfigurationvalue": SiteConfigurationValue,
    "labelterm": LabelTerm,
    "languageselector": LanguageSelector,
    "languagevaluesquery": LanguageValuesQuery,
    "linkedbooks": LinkedBooks,
    "markdownexportlink": MarkdownExportLink,
    "markdownexporturl": MarkdownExportUrl,
    "linkcontroller": LinkController,
    "linkverifier": LinkVerifier,
    "signinbutton": SignInButton,
    "logoutbutton": LogoutButton,
    "forgotpasswordbutton": ForgotPasswordButton,
    "filterstatecontroller": FilterStateController,
    "changepasswordbutton": ChangePasswordButton,
    "opendialogbutton": OpenDialogButton,
    "pageloader": PageLoader,
    "pathhasmarkdownchunks": PathHasMarkdownChunks,
    "fileoutlet": FileOutlet,
    "bookoutlet": BookOutlet,
    "parsehtml": ParseHtml,
    "removefavorite": RemoveFavorite,
    "renderpath": RenderPath,
    "resizablecolumn": ResizableColumn,
    "resizablecolumncontroller": ResizableColumnController,
    "setcurrentsearchhitbutton": SetCurrentSearchHitButton,
    "setcurrentverifiedlinkbutton": SetCurrentVerifiedLinkButton,
    "searchquery": SearchQuery,
    "similarquery": SimilarQuery,
    "sortarray": SortArray,
    "statebooleancheckbox": StateBooleanCheckbox,
    "statesetterinput": StateSetterInput,
    "statestringinput": StateStringInput,
    "storearray": StoreArray,
    "storedarray": StoredArray,
    "stringlength": StringLength,
    "substring": Substring,
    "systemfilter": SystemFilter,
    "systemversion": SystemVersion,
    "systempropertyfilternames": SystemPropertyFilterNames,
    "systempropertyfiltervalues": SystemPropertyFilterValues,
    "systempropertyselector": SystemPropertySelector,
    "systempropertyvaluesquery": SystemPropertyValuesQuery,
    "term": Term,
    "toggleswitch": ToggleSwitch,
    "toggleswitchcontroller": ToggleSwitchController,
    "usedbyquery": UsedByQuery,
    "validitymatrix": ValidityMatrix,
    "validitypath": ValidityPath,
    "validitypropertyfiltervalues": ValidityPropertyFilterValues,
    "validityselector": ValiditySelector,
    "validityvaluesquery": ValidityValuesQuery,
    "windowwidth": WindowWidth,
};

export function isParserCustomComponentRegistered(tagName: string): boolean {
    return Object.prototype.hasOwnProperty.call(customComponentMap, tagName.toLowerCase());
}

const attributeCaseMap: Record<string, string> = {
    "class": "className",
    "arialabel": "aria-label",
    "contenttype": "contentType",
    "propertynamearg": "propertyNameArg",
    "parentbaselineprop": "parentBaselineProp",
    "parentvalidityprop": "parentValidityProp",
    "validitypatharg": "validityPathArg",
    "requirevalidform": "requireValidForm",
    "inputprops": "inputProps",
    "starttrue": "startTrue",
    "requiredfields": "requiredFields",
    "issemantic": "isSemantic",
    "isdefault": "isDefault",
    "clickawaybreakpoint": "clickAwayBreakpoint",
    "hiddenbelowbreakpoint": "hiddenBelowBreakpoint",
    "minwidth": "minWidth",
    "maxwidth": "maxWidth",
    "autosizefromtoggle": "autoSizeFromToggle",
    "showseparator": "showSeparator",
    "resizestrategy": "resizeStrategy",
    "keyboardstep": "keyboardStep",
    "keyboardfinestep": "keyboardFineStep",
    "sendonenter": "sendOnEnter",
    "redirectlayout": "redirectLayout",
    "activate-toggle-switch": "activateToggleSwitch",
    "activatetoggleswitch": "activateToggleSwitch",
    "active-toggles": "activeToggles",
    "activetoggles": "activeToggles",
    "restricttobook": "restrictToBook",
};

function stripQueryPreserveHash(path: string): string {
    const hashIndex = path.indexOf("#");
    const hash = hashIndex >= 0 ? path.substring(hashIndex) : "";
    const pathWithoutHash = hashIndex >= 0 ? path.substring(0, hashIndex) : path;
    const queryIndex = pathWithoutHash.indexOf("?");
    const pathWithoutQuery = queryIndex >= 0 ? pathWithoutHash.substring(0, queryIndex) : pathWithoutHash;
    return `${pathWithoutQuery}${hash}`;
}

function isExcludedAnchorHref(href: string): boolean {
    return href.startsWith("/api/");
}

export function getRouterLinkPropsFromAnchorAttributes(attributes: Record<string, string> | undefined): (Record<string, string> & { to: string }) | null {
    const href = attributes?.href;
    if (!href || !href.startsWith("/") || href.startsWith("//")) {
        return null;
    }
    if (attributes?.target === "_blank" || attributes?.download !== undefined || isExcludedAnchorHref(href)) {
        return null;
    }

    const { href: _, ...remainingAttributes } = attributes;
    const mappedAttributes = Object.entries(remainingAttributes).reduce<Record<string, string>>((result, [key, value]) => {
        const mappedKey = key === "class" ? "className" : key;
        result[mappedKey] = value;
        return result;
    }, {});

    return {
        ...mappedAttributes,
        to: stripQueryPreserveHash(href)
    };
}

// Custom hook for parsing HTML/SVG to React
export const useParser = (): ((text: string) => React.ReactNode) => {
    const injectRules = useInjectElementRules();
    const cssRules = useCssClassRules();
    const internalState = useInternalState();
    const { siteState } = useSiteContext();
    const location = useLocation();
    const effectiveSitePath = internalState.isCustomDomain ? "" : (siteState.sitePath || "");

    const currentLayout = (() => {
        const pathname = location.pathname || "";
        const withoutSitePath = effectiveSitePath && pathname.startsWith(effectiveSitePath)
            ? pathname.substring(effectiveSitePath.length)
            : pathname;
        const [firstSegment] = withoutSitePath.split("/").filter(Boolean);
        return firstSegment?.startsWith("~") ? firstSegment.substring(1) : "";
    })();

    const createInternalStateBranch = useCreateInternalStateBranch();
    const { inBookOutlet } = useBookOutletScope();
    const { inFileOutlet } = useFileOutletScope();

    return useCallback((text: string) => {
        if (!text) return <></>;
        const processedText = processTemplates(text);
        let usedText = processedText;
        const startBodyIndex = processedText.indexOf("<body");
        const endBodyIndex = processedText.indexOf("</body>");

        if (startBodyIndex !== -1 && endBodyIndex !== -1) {
            usedText = "<div>" + processedText.substring(startBodyIndex + 6, endBodyIndex) + "</div>";
        }

        usedText = fixInternalLinks(usedText, effectiveSitePath, currentLayout, location.pathname || "");
        // In dev, client and server run on different ports; use full server origin for image src so requests hit the API server. In prod, path-only resolves to same origin.
        const fileApiOrigin = process.env.REACT_APP_SERVER_URL || "";
        const fileApiBase = fileApiOrigin + "/api/app/file/" + (siteState.site?.name || "");
        usedText = fixInternalImages(usedText, fileApiBase);

        // Extract and store unmanaged content before parsing
        const unmanagedContentMap = new Map<string, string>();
        const unmanagedContentRegex = /<unmanagedcontent[^>]*>(.*?)<\/unmanagedcontent>/gis;
        let match;
        let counter = 0;

        while ((match = unmanagedContentRegex.exec(usedText)) !== null) {
            const placeholder = `__UNMANAGED_CONTENT_${counter}__`;
            unmanagedContentMap.set(placeholder, match[1]);
            usedText = usedText.substring(0, match.index) +
                `<unmanagedcontent data-placeholder="${placeholder}"></unmanagedcontent>` +
                usedText.substring(match.index + match[0].length);
            counter++;
        }

        const options: HTMLReactParserOptions = {
            replace: (domNode: DOMNode) => {
                if (domNode.type === "tag") {
                    const tagName = domNode.name.toLowerCase();

                    // Handle HTML top elements
                    if (tagName === "html") {
                        // Pass through to children
                        return <>{domToReact(domNode.children as DOMNode[], options)}</>;
                    }
                    if (tagName === "head") {
                        // Skip completely
                        return <></>;
                    }
                    if (tagName === "body") {
                        // Convert to div
                        return <div>{domToReact(domNode.children as DOMNode[], options)}</div>;
                    }
                    if (tagName === "unmanagedcontent") {
                        console.log("Unmanaged content found");
                        // Look up the stored content using the placeholder
                        const placeholder = domNode.attribs?.['data-placeholder'];
                        const rawHtml = placeholder ? unmanagedContentMap.get(placeholder) || '' : '';
                        return <UnmanagedContent unparsedHtml={rawHtml} />;
                    }

                    if (tagName === "a") {
                        const linkProps = getRouterLinkPropsFromAnchorAttributes(domNode.attribs);
                        if (linkProps) {
                            const { to, ...anchorRest } = linkProps;
                            return React.createElement(AppLink, {
                                ...anchorRest,
                                to,
                                children: domToReact(domNode.children as DOMNode[], options),
                            });
                        }
                    }

                    // Check for injection rules
                    const matchingInjectRules = injectRules?.filter(rule => rule.id === domNode.attribs.id) || [];
                    if (matchingInjectRules.length > 0) {
                        // Only allow one inject rule per element
                        const rule: InjectElementRule = matchingInjectRules[0];

                        // Remove the rule in a state branch so it does not run again
                        const BranchComponent = createInternalStateBranch({
                            injectElementRules: injectRules?.filter(rule => rule.id !== domNode.attribs.id) || []
                        });
                        return <BranchComponent>
                            {
                                React.createElement(rule.element.type, rule.element.props,
                                    React.createElement(domNode.name, domNode.attribs,
                                        domToReact(domNode.children as DOMNode[], options)))
                            }
                        </BranchComponent>;
                    }

                    // Check for matching CSS rules
                    const matchingCssRules = cssRules?.filter(rule => rule.id === domNode.attribs.id) || [];

                    if (matchingCssRules.length > 0) {
                        let existingClasses = new Set((domNode.attribs.class || "").split(/\s+/).filter(Boolean));

                        matchingCssRules.forEach(rule => {
                            const shouldApplyClass = evaluateBooleanExpression(rule.rule);
                            if (shouldApplyClass) {
                                existingClasses.add(rule.className);
                            } else {
                                existingClasses.delete(rule.className);
                            }
                        });

                        return React.createElement(domNode.name,
                            {
                                ...domNode.attribs,
                                className: Array.from(existingClasses).join(" ") || undefined
                            },
                            domToReact(domNode.children as DOMNode[], options));
                    }

                    const isFileOutletLikeTag = tagName === "fileoutlet" || tagName === "pageloader" || tagName === "pagerouter";
                    if (isFileOutletLikeTag && inFileOutlet) {
                        console.warn(`Blocked nested ${tagName} render inside FileOutlet to prevent recursive render loops.`);
                        return null;
                    }

                    const isBookOutletTag = tagName === "bookoutlet";
                    if (isBookOutletTag && inBookOutlet) {
                        console.warn("Blocked nested bookoutlet render inside BookOutlet to prevent recursive render loops.");
                        return null;
                    }

                    // Check if this is a custom component
                    const CustomComponent = customComponentMap[tagName];
                    if (CustomComponent) {

                        // Extract props from attributes
                        const props: Record<string, string> = {};
                        if (domNode.attribs) {
                            Object.entries(domNode.attribs).forEach(([key, value]) => {
                                const mappedKey = attributeCaseMap[key] || key;
                                props[mappedKey] = value;
                            });
                        }

                        // Handle children using domToReact
                        return (
                            <CustomComponent {...props}>
                                {domToReact(domNode.children as DOMNode[], options)}
                            </CustomComponent>
                        );
                    }

                    // Check if this is a deprecated component
                    const DeprecatedComponent = deprecatedComponents[tagName];
                    if (DeprecatedComponent) {
                        console.warn(`The component ${DeprecatedComponent.tag} is deprecated. ${DeprecatedComponent.message}`);

                        // Extract props from attributes
                        const props: Record<string, string> = {};
                        if (domNode.attribs) {
                            Object.entries(domNode.attribs).forEach(([key, value]) => {
                                const mappedKey = attributeCaseMap[key] || key;
                                props[mappedKey] = value;
                            });
                        }

                        return <DeprecatedComponent.Replacement {...props}>
                            {domToReact(domNode.children as DOMNode[], options)}
                        </DeprecatedComponent.Replacement>;
                    }
                }

                // Return undefined to let the parser handle it
                return undefined;
            }
        };
        return parse(usedText, options);
    }, [currentLayout, injectRules, cssRules, effectiveSitePath, siteState.site?.name, createInternalStateBranch, location.pathname, inBookOutlet, inFileOutlet]);
};


export function processTemplates(inputHtml: string): string {
    const root = htmlParse(`${inputHtml}`);

    const templateMap: Record<string, string> = {};

    // 1. Collect templates into raw form (with unresolved ApplyTemplates)
    const saveTemplates = root.querySelectorAll('savetemplate');
    for (const saveTemplate of saveTemplates) {
        const name = saveTemplate.getAttribute('name');
        const argTemplate = saveTemplate.querySelector('arg-template');
        if (name) {
            if (argTemplate) {
                // Allow arg-template sub element for backwards compatibility
                templateMap[name] = argTemplate.innerHTML;
            } else {
                templateMap[name] = saveTemplate.innerHTML;
            }
        }
        saveTemplate.remove();
    }

    // 2. Recursively resolve templates
    function resolveTemplateContent(html: string, seen: Set<string> = new Set()): string {
        const templateHtml = htmlParse(html);

        let applyTemplate = templateHtml.querySelector('applytemplate');
        let ix = 0;
        while (applyTemplate) {
            const name = applyTemplate.getAttribute('name');
            if (!name || !templateMap[name]) continue;

            let templateContent = "";
            if (seen.has(name)) {
                console.error(`Circular template reference detected: ${[...seen, name].join(' -> ')}`);
            } else {
                templateContent = resolveTemplateContent(templateMap[name], new Set([...seen, name]));
            }

            // Parse resolved content into nodes
            const parsed = htmlParse(templateContent);

            // Replace ApplyTemplate with resolved nodes
            const parent = applyTemplate.parentNode as HTMLElement;
            const siblings = parent.childNodes;
            const index = siblings.indexOf(applyTemplate);
            const before = siblings.slice(0, index);
            const after = siblings.slice(index + 1);

            parent.childNodes = [...before, ...parsed.childNodes, ...after];
            parent.set_content(parent.innerHTML);
            templateHtml.set_content(templateHtml.innerHTML);
            applyTemplate = templateHtml.querySelector('applytemplate');
            if (++ix > 50) {
                throw new Error("Infinite loop detected in template " + name);
            }
        }

        return templateHtml.innerHTML;
    }

    // Resolve all templates recursively
    for (const name of Object.keys(templateMap)) {
        try {
            templateMap[name] = resolveTemplateContent(templateMap[name], new Set([name]));
        } catch (error) {
            console.error(`Error resolving template ${name}: ${error}`);
        }
    }

    // 3. Replace ApplyTemplates in main document
    const applyTemplates = root.querySelectorAll('applytemplate');
    for (const applyTemplate of applyTemplates) {
        const name = applyTemplate.getAttribute('name');
        const templateHtml = name ? templateMap[name] : null;
        if (!templateHtml) {
            console.error(`Template ${name} not found`);
            continue;
        }

        if (templateHtml && applyTemplate.parentNode instanceof HTMLElement) {
            const parent = applyTemplate.parentNode;
            const siblings = parent.childNodes;
            const index = siblings.indexOf(applyTemplate);

            const parsedTemplate = htmlParse(`${templateHtml}`);
            const newNodes = parsedTemplate.childNodes;

            const before = siblings.slice(0, index);
            const after = siblings.slice(index + 1);
            parent.childNodes = [...before, ...newNodes, ...after];
        }
    }

    // 4. Return the final HTML
    return root.innerHTML;
}
